import React from 'react';
import { Popup, Icon } from 'semantic-ui-react';
import './CartActionNotification.css';
var defaultProps = {};
export default function CartActionNotification(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    trigger = _ref.trigger,
    message = _ref.message;
  return /*#__PURE__*/React.createElement(Popup, {
    content: /*#__PURE__*/React.createElement("div", null, message, /*#__PURE__*/React.createElement(Icon, {
      onClick: onClose,
      name: "close"
    })),
    trigger: trigger,
    open: open,
    position: "left center",
    className: "cart-action-notification"
  });
}
CartActionNotification.defaultProps = defaultProps;